import type { CampaignState } from '../campaign/types';
import { createStateTag } from 'components/StateTag';

export const CampaignStateTag = createStateTag<CampaignState>({
  testId: 'campaign-state-tag',
  stateVariantMap: {
    NEW: { icon: 'clock', variant: 'danger' },
    IN_PROCESS: { icon: 'play', variant: 'primary' },
    DONE: { icon: 'circle-check', variant: 'success' },
    CANCELED: { icon: 'circle-xmark', variant: 'secondary' },
  },
  // FIXME
  displayTransform: (state) => (state === 'IN_PROCESS' ? 'ACTIVE' : state),
});
